import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';
import { closeModal } from '../modules/active_modal';
import PriceGuideNonBundle from './PriceGuideNonBundle.jsx';

class PriceGuide extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { dispatch, store } = this.props
    if( !store.bundle_pricing ) return <PriceGuideNonBundle />;
    return (
      <div className="modal-window price-guide">
        <div className="modal-close" onClick={() => dispatch( closeModal() )}>&times;</div>
        <h2>A Guide to Our Simplified Prices</h2>
        <section>
        <p>
          You can lower the membership price and earn savings in two ways:
        </p>
        <div className="half-col">
          <h4 className="alt2 primary-color">Member Credits:</h4>
          <p>
            Buy Member Credits during the first 10 days of the month for only ${this.props.store.one_credit} each and redeem them for any book on the site.
          </p>
          <h5 className="primary-color">(Save over 20%)</h5>
        </div>
        <div className="half-col">
          <h4 className="alt2 primary-color">Featured Selection Bundles:</h4>
          <p>
            Buy one of our three Featured Selections and select any second book for ${this.props.store.second_book} and a third for only ${this.props.store.third_book}.
          </p>
          <h5 className="primary-color">(Save over 40%)</h5>
        </div>
        </section>
        <section>
          <p>
            All pre-orders are available at the membership price or one Member Credit, and because they are shipped separately, pre-orders are not eligible for Feature Selection Bundle prices.
          </p>
          <p>
            <a href="/member-services" className="button btn-tertiary" onClick = {(evt) => this.props.dispatch([navigate(evt), closeModal()])}>Visit the faqs for more details</a>
          </p>
        </section>
      </div>
    );
  }
};

function mapStateToProps(state){
    return { 'store': state.store };
}

export default connect(mapStateToProps)(PriceGuide);



// WEBPACK FOOTER //
// ./src/components/PriceGuide.jsx